import { Camera, CameraResultType } from "@capacitor/camera";
import {
  ConfirmarImagen,
  ContainerCantidadOrdenes,
  ContainerFrenteOrden,
  ContainerSeleccionarOrdenes,
  ContainerSubirOrden,
} from "./localStyle";
import ordenImage from "_+_Portal/assets/images/generico/OrdenMiniatura.png";
import { useState } from "react";

const FrenteOrden = ({ idTurno, finalizarProceso }) => {
  const [step, setStep] = useState("inicio"); // cantidadOrdenes || subirOrdenes
  const [cantidadOrdenes, setCantidadOrdenes] = useState(1);
  const [ordenActual, setOrdenActual] = useState(1);
  const [imageCamera, setImageCamera] = useState([]);

  const siguientePaso = () => {
    setStep("cantidadOrdenes");
  };

  const aceptarMasDeUnaOrden = (masDeUnaOrden) => {
    if (masDeUnaOrden) {
      setCantidadOrdenes(masDeUnaOrden);
      setStep("cantidadOrdenes");
    } else {
      setStep("subirOrdenes");
    }
  };

  const subirOrdenes = () => {
    setStep("subirOrdenes");
  };

  const onClickSelection = (idBtn, e) => {
    if (idBtn === 1) {
      const btnOne = document.getElementById("btn-selection-2");
      btnOne.className = "selection";
      const btnTwo = document.getElementById("btn-selection-3");
      btnTwo.className = "selection";
      e.target.className = "selection active";
      setCantidadOrdenes(1);
    }
    if (idBtn === 2) {
      const btnOne = document.getElementById("btn-selection-1");
      btnOne.className = "selection";
      const btnTwo = document.getElementById("btn-selection-3");
      btnTwo.className = "selection";
      e.target.className = "selection active";
      setCantidadOrdenes(2);
    }
    if (idBtn === 3) {
      const btnOne = document.getElementById("btn-selection-2");
      btnOne.className = "selection";
      const btnTwo = document.getElementById("btn-selection-1");
      btnTwo.className = "selection";
      e.target.className = "selection active";
      setCantidadOrdenes(3);
    }
  };

  const tomarFoto = () => {
    const takePicture = async () => {
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: true,
        resultType: CameraResultType.DataUrl,
      });
      const imageUrl = image.dataUrl;
      let lista = [...imageCamera];
      lista[ordenActual - 1] = imageUrl;
      setImageCamera(lista);
      setStep("");
    };
    takePicture();
  };

  const confirmarImage = (success) => {
    const siguiente = ordenActual + 1;
    if (!success) {
      setStep("subirOrdenes");
    } else if (siguiente <= cantidadOrdenes) {
      setOrdenActual((ordenActual) => ordenActual + 1);
      setStep("subirOrdenes");
    } else {
      const listaDefinitiva = imageCamera.map((image) => {
        const obj = tipoImage(image);
        return {
          binario: obj.base64,
          idRemoto: idTurno,
          tag: obj.type,
          autocheck: true,
        };
      });
      finalizarProceso(listaDefinitiva, "frenteOrden");
    }
  };
  const tipoImage = (url) => {
    url = url.split(",");
    const type = url[0].replace("data:image/", "").replace("base64", "");
    const base64 = url[1];

    return {
      type,
      base64,
    };
  };

  const renderStep = () => {
    switch (step) {
      case "inicio":
        return (
          <ContainerSeleccionarOrdenes
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <span>Foto Orden</span>
            <span>¿Cuenta con más de una orden para este turno?</span>
            <div className="container-images">
              <img
                className="first-image"
                src={ordenImage}
                alt="ordenes de autocheckin"
              />
              <img
                className="second-image"
                src={ordenImage}
                alt="ordenes de autocheckin"
              />
            </div>

            <div className="container-btn">
              {/* <button onClick={galeria} className="bgc-primary">Galeria</button> */}
              <button
                onClick={() => aceptarMasDeUnaOrden(false)}
                className="bgc-danger"
              >
                NO
              </button>
              <button
                onClick={() => aceptarMasDeUnaOrden(true)}
                className="bgc-broccoli"
              >
                SI
              </button>
            </div>
          </ContainerSeleccionarOrdenes>
        );
      case "cantidadOrdenes":
        return (
          <ContainerCantidadOrdenes
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <span>Foto Orden</span>
            <span>
              Seleccione la cantidad de ordenes con las que cuenta para este
              turno
            </span>
            <div className="container-btn">
              <div className="container-btn-selection">
                <button
                  onClick={(e) => onClickSelection(1, e)}
                  className="selection"
                  id="btn-selection-1"
                >
                  1
                </button>
                <button
                  onClick={(e) => onClickSelection(2, e)}
                  className="selection"
                  id="btn-selection-2"
                >
                  2
                </button>
                <button
                  onClick={(e) => onClickSelection(3, e)}
                  className="selection"
                  id="btn-selection-3"
                >
                  3
                </button>
              </div>
            </div>
            <div className="container-avanzar">
              <button onClick={subirOrdenes} className="bgc-primary">
                Avanzar
              </button>
            </div>
          </ContainerCantidadOrdenes>
        );

      case "subirOrdenes":
        return (
          <ContainerSubirOrden
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <span>Foto Orden</span>
            <span>Sacá o subí una foto del frente de la orden médica</span>
            <span className="subtitle">
              Orden {ordenActual} de {cantidadOrdenes}
            </span>
            <div className="container-images">
              <img
                className="first-image"
                src={ordenImage}
                alt="ordenes de autocheckin"
              />
            </div>
            <div className="container-avanzar">
              <button onClick={tomarFoto} className="bgc-primary">
                Camara
              </button>
            </div>
          </ContainerSubirOrden>
        );
      default:
        return (
          <ConfirmarImagen
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <span>Foto Orden</span>
            <span>¿El frente de orden se visualiza correctamente?</span>
            <div className="container-images">
              <img
                className="first-image"
                src={imageCamera[ordenActual - 1]}
                alt="ordenes de autocheckin"
              />
            </div>
            <div className="container-btn">
              <button
                onClick={() => confirmarImage(false)}
                className="bgc-danger"
              >
                NO
              </button>
              <button
                onClick={() => confirmarImage(true)}
                className="bgc-broccoli"
              >
                SI
              </button>
            </div>
          </ConfirmarImagen>
        );
    }
  };

  return renderStep();
};

export default FrenteOrden;
